import handleError from "./handle-error";
import api from "../api";
import axios from "../utils/axios.instance";

// Experience
export const getCertificateOrEducation = async (payload) => {
  try {
    const { data } = await axios.get(
      api.getCertificateOrEducation,
      payload ? { params: payload } : undefined
    );
    return data;
  } catch (err) {
    return handleError(err);
  }
};

export const addCertificateOrEducation = async (payload) => {
  try {
    const { data } = await axios.post(api.addCertificateOrEducation, payload);
    return data;
  } catch (err) {
    return handleError(err);
  }
};

export const updateCertificateOrEducation = async (payload) => {
  try {
    const { data } = await axios.patch(
      api.updateCertificateOrEducation,
      payload
    );
    return data;
  } catch (err) {
    return handleError(err);
  }
};
